import { render, staticRenderFns } from "./Programm.vue?vue&type=template&id=7f6c06d5&scoped=true&"
import script from "./Programm.vue?vue&type=script&lang=js&"
export * from "./Programm.vue?vue&type=script&lang=js&"
import style0 from "./Programm.vue?vue&type=style&index=0&id=7f6c06d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c06d5",
  null
  
)

export default component.exports